import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { getClientIpAddress } from '@/redux/modules/browser';
import { getDeployment } from '@/redux/modules/config';
import { fetchItemSummaries } from '@/redux/modules/item/summary/itemSummary.actions';
import { getUserExcludedFacets } from '@/redux/modules/search/exclusions/searchExclusions.selectors';
import { isErrorResponse } from '@/redux/modules/search/search.types';

import { fetchPriceResultsMoreFromCategory } from './priceResultsMoreFrom.api';
import { MORE_FROM_LIMIT, type FetchPriceResultsMoreFromArgs } from './priceResultsMoreFrom.types';

export const fetchPriceResultsMoreFromIfNeeded = createAsyncThunk(
    'priceResultsMoreFrom/fetchIfNeeded',
    async ({ excludeItemId, source }: FetchPriceResultsMoreFromArgs, { dispatch, getState }) => {
        if (!source) {
            return [];
        }
        const state = getState();
        const response = await fetchPriceResultsMoreFromCategory({
            authToken: getAuthToken(state),
            deployment: getDeployment(state),
            excludedFacets: getUserExcludedFacets(state),
            ipAddress: getClientIpAddress(state),
            source,
        });
        if (isErrorResponse(response) || !response.payload?.itemIDs) {
            return [];
        }
        const itemIds = response.payload.itemIDs.filter((id) => id !== excludeItemId).slice(0, MORE_FROM_LIMIT);
        if (itemIds.length > 0) {
            await dispatch(fetchItemSummaries({ identifier: 'price-results-more-from-items', itemIds }));
        }
        return itemIds;
    },
    {
        condition: ({ itemId, source }, { getState }) => {
            if (!source || itemId <= 0) {
                return false;
            }
            const slice = getState().priceResultsMoreFrom;
            if (slice.loading || (slice.loaded && slice.sourceItemId === itemId)) {
                return false;
            }
            return true;
        },
    }
);
